import React from "react";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

const SureModal = ({ isOpen, onClose,onConfirm, title, actionType}) => {
  const isDeactivate = actionType === "Deactivate";
    const { COLORS } = useThemeMode();
  
  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      tabIndex="-1"
      style={{
        display: isOpen ? "block" : "none",
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ background: COLORS.primary }}>
          <div className="modal-body text-center">
            <span className="fw-normal" style={{ color: COLORS.text }}>
              Are you fine to <b>{actionType?.toLowerCase()}</b> {title} <br />
            {isDeactivate
                ? `This will immediately suspend related users and resources.`
                : `This will allow related users and resources to function again.`}
            </span>
          </div>
          <div className="modal-footer d-flex flex-column justify-content-center border-0">
            <button
              type="button"
              className="btn rounded-2 fw-medium w-50"
              onClick={onConfirm}
              style={{ background: COLORS.button, color: COLORS.background }}
            >
              {actionType} {title}
            </button>
            <button
              type="button"
              className="btn rounded-2 fw-medium w-50"
              onClick={onClose}
              style={{ background: COLORS.background, color: COLORS.button }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SureModal;